module.exports = __webpack_public_path__ + "media/media/home/img6-cce451947b710b9c2eac8eedc973557c.png";